import { message } from 'antd';
import i18next from '../../i18next';

export function whenAddressIsRemoved() {
  message.success({
    content: i18next.t('profile.notifications.whenAddressIsRemoved')
  });
}

export function whenAddressIsFailedToBeRemoved(text?: string) {
  return message.error({
    content: `${i18next.t('profile.notifications.whenAddressIsFailedToBeRemoved')}: ${text || ''}`
  });
}
